import React, { useMemo } from 'react';

import { FlexStyle, Platform, StyleSheet, View, ViewProps, ViewStyle } from 'react-native';

import { _spacing as spacing } from 'styles/constants/spacing';
import { WEB_APP_MAX_WIDTH_DESKTOP_LARGE } from 'utils/constants';

type CenteredRowContainerProps = {
  children: React.ReactNode;
  containerStyle?: ViewStyle;
  // easily set flex direction to row if needed
  contentFlexDirection?: FlexStyle['flexDirection'];
  // apply standard horizontal padding
  standardPadding?: boolean;
} & ViewProps;

/**
 *  provides a high performing centered row container that is constrained to desktop max width
 *  - add more styles as makes sense for a generic component
 */
export const CenteredRowContainer: React.FC<CenteredRowContainerProps> = React.memo(
  ({ children, containerStyle, contentFlexDirection, standardPadding, style, ...props }) => {
    const mergedContentStyle = useMemo(() => {
      return [
        centeredRowContainerStyles.content,
        contentFlexDirection ? { flexDirection: contentFlexDirection } : {},
        standardPadding ? { paddingHorizontal: spacing.$4 } : {},
        style,
      ];
    }, [contentFlexDirection, standardPadding, style]);

    return (
      <View style={[centeredRowContainerStyles.container, containerStyle]} {...props}>
        <View style={mergedContentStyle}>{children}</View>
      </View>
    );
  }
);

export const centeredRowContainerStyles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    width: '100%',
    maxWidth: WEB_APP_MAX_WIDTH_DESKTOP_LARGE,
    ...(Platform.OS === 'web' ? { alignSelf: 'center' } : null), // only used on desktop web
  },
});
